import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";

export interface SlsCustomerItem {
    label: string
    customerNumber: string
    id: string
}

class SlsCustomerStore {
    get items(): SlsCustomerItem[] {
        return this._items;
    }

    set items(value: SlsCustomerItem[]) {
        this._items = value;
    }

    private _items: SlsCustomerItem[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async search(query: string): Promise<SlsCustomerItem[]> {
        const response = await catchApi(async () => api.sls.api.findCustomers({query: query}))
        return (response?.data || []).map(item => ({
            label: `${item.name}${item.displayName ? ` [${item.displayName}]` : ''} (${item.customerNumber})`,
            customerNumber: `${item.customerNumber}`,
            id: `${item.customerId}`
        }))
    }

    async init() {
        const response = await catchApi(async () => api.sls.api.findCustomers())
        if (response && response.data) {
            this.items = (response.data || []).map(item => ({
                label: `${item.name}${item.displayName ? ` [${item.displayName}]` : ''} (${item.customerNumber})`,
                customerNumber: `${item.customerNumber}`,
                id: `${item.customerId}`
            }))
        }
    }

    getCustomerFromStoreById(customerId: string): SlsCustomerItem | undefined {
        const customerItem = slsCustomerStore.items.filter(e => e.id === customerId)[0]
        return customerItem || {
            id: customerId,
            label: `Unknown (${customerId})`
        };
    }

}

const slsCustomerStore = new SlsCustomerStore()

export {
    slsCustomerStore
}
